<div class="p-4 flex flex-col gap-y-4 basis-full flex-grow app-full-height">
  <form
    #customerForm="ngForm"
    fxLayout="column"
    fxLayoutGap="15px"
    *ngIf="model"
  >
    <div fxLayout="row" fxLayoutAlign="start center">
      <div fxFlex>
        <h3>Edit Customer</h3>
      </div>
      <button mat-flat-button (click)="deleteCustomer()">
        Delete Customer
      </button>
    </div>
    <div
      fxLayout="row"
      class="customer-type"
      fxLayoutAlign="center center"
      fxLayoutAlign.gt-sm="start center"
    >
      <mat-radio-group
        [(ngModel)]="model.business"
        name="Business"
        (change)="typeChanged($event)"
        fxLayout="row"
        fxLayoutGap="14px"
      >
        <mat-radio-button [value]="0">Individual</mat-radio-button>
        <mat-radio-button [value]="1">Organisation</mat-radio-button>
      </mat-radio-group>
    </div>
    <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap="15px">
      <mat-card
        appearance="outlined"
        fxLayout="column"
        fxFlex="50"
        fxLayoutGap="12px"
      >
        <mat-card-content>
          <div
            *ngIf="model.business === 0"
            fxLayoutGap="12px"
            fxLayout="column"
          >
            <div fxLayout="row">
              <h3 fxFlex>Personal Details</h3>
              <mat-slide-toggle
                color="warn"
                [checked]="true"
                name="Hires Disabled"
                [(ngModel)]="model.hires_disabled"
              >
                <ng-container *ngIf="model.hires_disabled"
                  >Hires Disabled
                </ng-container>
                <ng-container *ngIf="!model.hires_disabled"
                  >Hires Enabled
                </ng-container>
              </mat-slide-toggle>
            </div>
            <div fxLayout="row" fxLayoutGap="8px">
              <mat-form-field fxFlex="50">
                <input
                  matInput
                  placeholder="First Name"
                  name="First name"
                  [(ngModel)]="model.first_name"
                  required
                />
              </mat-form-field>
              <mat-form-field fxFlex="50">
                <input
                  matInput
                  placeholder="Last Name"
                  name="Last name"
                  [(ngModel)]="model.last_name"
                  required
                />
              </mat-form-field>
            </div>
          </div>
          <div *ngIf="model.business === 1" fxLayoutGap="12px">
            <div fxLayout="row">
              <h3 fxFlex>Organisation Details</h3>
              <mat-slide-toggle
                color="warn"
                [checked]="true"
                name="Hires Disabled"
                [(ngModel)]="model.hires_disabled"
              >
                <ng-container *ngIf="model.hires_disabled"
                  >Hires Disabled
                </ng-container>
                <ng-container *ngIf="!model.hires_disabled"
                  >Hires Enabled
                </ng-container>
              </mat-slide-toggle>
            </div>
            <div fxLayout="row" fxLayoutGap="8px">
              <mat-form-field fxFlex="50">
                <input
                  matInput
                  placeholder="Name"
                  name="name"
                  [(ngModel)]="model.business_name"
                  required
                />
              </mat-form-field>
              <mat-form-field fxFlex="50">
                <input
                  matInput
                  placeholder="VAT Number"
                  name="vat number"
                  [(ngModel)]="model.vat_number"
                />
              </mat-form-field>
            </div>
          </div>
          <h3>Contact Details</h3>
          <div fxLayout="row" fxLayoutGap="8px">
            <mat-form-field fxFlex="50">
              <input
                type="tel"
                matInput
                placeholder="Telephone"
                name="Telephone"
                [(ngModel)]="model.telephone"
                required
              />
            </mat-form-field>
            <mat-form-field fxFlex="50">
              <input
                type="email"
                matInput
                placeholder="Email"
                name="Email"
                [(ngModel)]="model.email"
              />
            </mat-form-field>
          </div>
          <div fxLayout="row" fxLayoutGap="8px">
            <mat-form-field fxFlex="50">
              <input
                matInput
                type="tel"
                placeholder="Telephone 2"
                name="Telephone 2"
                [(ngModel)]="model.alt_telephone"
              />
            </mat-form-field>
            <mat-form-field fxFlex="50">
              <input
                type="tel"
                matInput
                placeholder="Telephone 3"
                name="Telephone 3"
                [(ngModel)]="model.mobile"
              />
            </mat-form-field>
          </div>
        </mat-card-content>
      </mat-card>
      <mat-card appearance="outlined" fxLayout="column" fxFlex="50">
        <mat-card-content>
          <h3>Address</h3>
          <div fxLayout="row">
            <mat-form-field fxFlex="100">
              <input
                matInput
                placeholder="Address line 1"
                name="Address line 1"
                [(ngModel)]="model.address_1"
                required
              />
            </mat-form-field>
          </div>
          <div fxLayout="row">
            <mat-form-field fxFlex="100">
              <input
                matInput
                placeholder="Town/City"
                name="Town/City"
                [(ngModel)]="model.city"
                required
              />
            </mat-form-field>
          </div>
          <div fxLayout="row">
            <mat-form-field fxFlex="100">
              <input
                matInput
                placeholder="Postal Code"
                name="Post code"
                [(ngModel)]="model.post_code"
              />
            </mat-form-field>
          </div>
          <div fxLayout="row">
            <mat-form-field fxFlex="100">
              <input
                matInput
                placeholder="County"
                name="County"
                [(ngModel)]="model.county"
              />
            </mat-form-field>
          </div>
          <div fxLayout="row">
            <mat-form-field fxFlex="100">
              <input
                matInput
                placeholder="Country"
                name="Country"
                [(ngModel)]="model.country"
              />
            </mat-form-field>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
    <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap="15px">
      <mat-card appearance="outlined" fxLayout="column" fxFlex="50">
        <mat-card-content>
          <h3>Account Details</h3>
          <div fxLayout="row">
            <mat-form-field fxFlex="100">
              <input
                matInput
                placeholder="Account Number"
                name="Account Number"
                [(ngModel)]="model.account_number"
              />
            </mat-form-field>
          </div>

          <div fxLayout="row" fxLayoutGap="8px" fxLayoutAlign="start center">
            <mat-checkbox
              [(ngModel)]="model.extras.require_po"
              name="Requires Purchase Orders"
            ></mat-checkbox>
            <p>Require Purchase Orders</p>
          </div>
        </mat-card-content>
      </mat-card>
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        fxFlex="50"
        fxLayoutGap="12px"
      >
        <button mat-flat-button (click)="backToCustomer()">Cancel</button>
        <button
          mat-flat-button
          color="primary"
          [disabled]="!customerForm.valid"
          (click)="submit()"
        >
          Update Customer
        </button>
      </div>
    </div>
  </form>
</div>
